import 'swiper/css';
import 'swiper/css/effect-fade';
import Swiper, { Autoplay, Navigation, Pagination } from 'swiper';
Swiper.use([Navigation, Pagination, Autoplay]);
/**
 * Internal files
 */
import SwiperProgress from './swiperProgress';
export class ImageSlider {
    el;
    slider;
    slideProgress;
    swiper;
    constructor(el) {
        this.el = el;
        this.slider = el.querySelector('.swiper');
        if (this.slider) {
            const interleaveOffset = 0.5;
            const transition = 2000;
            const autoplayDelay = 4000;
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            const _this = this;
            if (this.el.querySelector('.swiper-slide-progress')) {
                const progressBar = this.el.querySelector('.swiper-slide-progress');
                if (progressBar) {
                    this.slideProgress = new SwiperProgress(progressBar);
                    this.slideProgress.update(0);
                    this.slideProgress.progressStart(autoplayDelay, true);
                }
            }
            this.swiper = new Swiper(this.slider, {
                slidesPerView: 1,
                allowTouchMove: true,
                grabCursor: true,
                autoplay: {
                    delay: autoplayDelay,
                    disableOnInteraction: false,
                },
                loop: true,
                speed: transition,
                watchOverflow: true,
                watchSlidesProgress: true,
                navigation: {
                    nextEl: this.el.querySelector('.swiper-button-next'),
                    prevEl: this.el.querySelector('.swiper-button-prev'),
                },
                pagination: {
                    el: this.el.querySelector('.swiper-pagination'),
                    type: 'fraction',
                },
                on: {
                    progress: function (el) {
                        for (let i = 0; i < el.slides.length; i++) {
                            const slide = el.slides[i];
                            const slideProgress = slide.progress;
                            const innerOffset = el.width * interleaveOffset;
                            const innerTranslate = slideProgress * innerOffset;
                            slide.querySelector('figure').style.transform = `translate3d(${innerTranslate}px,0, 0)`;
                        }
                    },
                    slideChangeTransitionStart: function (el) {
                        _this.slideProgress?.progressStop();
                        _this.slideProgress?.progressStart(transition, false);
                    },
                    slideChangeTransitionEnd: function (el) {
                        _this.slideProgress?.progressStop();
                        _this.slideProgress?.progressStart(autoplayDelay, true);
                    },
                    setTransition: function (el, speed) {
                        for (let i = 0; i < el.slides.length; i++) {
                            const slide = el.slides[i];
                            slide.style.transition = `${speed}ms`;
                            slide.querySelector('figure').style.transition = `${speed}ms`;
                        }
                    },
                    touchStart: function (el) {
                        for (let i = 0; i < el.slides.length; i++) {
                            const slide = el.slides[i];
                            slide.style.transition = '';
                        }
                    },
                }
            });
        }
    }
}
